/*
    Second panel in Overview showing Cumulative Material Usage
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {getMaterialUsage} from "../actions/getMaterialUsage";
import {bindActionCreators} from "redux";
import {Table} from "react-bootstrap";
import MaterialsCard from '../components/material-card.js';
import {startFetchingMaterialUsageOfPrinter, startFetchingPrintsNumber} from "../actions/getPrinterStatistics";
import LoadingAnimation from "../components/loading-animation";

// TODO: make material usage panel a card
class MaterialUsagePanel extends Component {
    constructor(props) {
        super(props);
    }

    componentWillReceiveProps(nextProps) {
        const prevPrinterIds = this.props.printerStatus.printerIds;
        const nextPrinterIds = nextProps.printerStatus.printerIds;
        if (prevPrinterIds.length === 0 && nextPrinterIds.length !== 0) {
            this.getStatisticsForEachPrinter(nextPrinterIds);
        }
    }

    componentDidMount() {
        const {printerIds} = this.props.printerStatus;
        if (printerIds.length !== 0) {
            this.getStatisticsForEachPrinter(printerIds);
        }
    }

    getStatisticsForEachPrinter(printerIds) {
        printerIds.forEach(printerId => {
            this.props.startFetchingMaterialUsageOfPrinter(printerId);
            this.props.startFetchingPrintsNumber(printerId)
        });
    }

    componentWillMount() {
        this.fetchMaterialUsage();
    }

    render() {
        return (
            <div>{this.getContentToDisplay()}</div>
        );

    }

    getContentToDisplay() {
        if (this.props.loading) {
            return <LoadingAnimation/>
        } else if (this.props.error) {
            return <div>Failed to load material usage</div>
        } else {
            return this.getCumulativeBarComponents()
        }
    }

    fetchMaterialUsage() {
        if (!this.props.userProfile || !this.props.userProfile.profile) return;
        const profile = this.props.userProfile.profile;
        this.props.getMaterialUsage(profile.sub);
    }

    getCumulativeBarComponents() {
        let totalPrintsOfAllPrinters = 0;
        let totalResinUsage = 0;

        for (let curPrinter in this.props.printerStatistics) {
            totalPrintsOfAllPrinters += this.props.printerStatistics[curPrinter].printsNumber;
        }

        for (let allPrinters in this.props.totalMaterialUsage) {
            totalResinUsage += this.props.totalMaterialUsage[allPrinters]
        }

        if (this.props.loading) {
            return <LoadingAnimation/>
        }
        const materialUsageByResinColor = this.props.totalMaterialUsage;
        if (!materialUsageByResinColor) return;

        return <MaterialsCard
            materialUsageByResinName={materialUsageByResinColor}
            totalNumberOfPrints={totalPrintsOfAllPrinters}
            totalUsageOfResin={totalResinUsage}
        />
    }
}

const mapStateToProps = state => ({
    ...state.materialUsage,
    printerStatus: state.printerStatus,
    userProfile: state.userProfile,
    printerStatistics: state.printerStatistics

});
const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        getMaterialUsage,
        startFetchingMaterialUsageOfPrinter,
        startFetchingPrintsNumber
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(MaterialUsagePanel);


// WEBPACK FOOTER //
// ./src/containers/material_usage_panel.js